<!-- ------------------------------------------------------------------------------------ -->
<!--   Vuetify Alert Dialog component                                                     -->
<!--   Courtesy if https://gist.github.com/eolant/ba0f8a5c9135d1a146e1db575276177d        -->
<!-- ------------------------------------------------------------------------------------ -->

<template>

	<v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel" persistent>
		<v-card>
		<v-toolbar dark :color="options.color" dense flat>
			<v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
		</v-toolbar>
		<v-card-text v-show="!!message" class="pa-4">{{ message }}</v-card-text>
		<v-card-actions class="pt-0">
			<v-spacer></v-spacer>
			<v-btn color="primary darken-1" text @click.native="ok">OK</v-btn>
		</v-card-actions>
		</v-card>
	</v-dialog>

</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

export default
{
	data: () =>
	({
		dialog: false,
		resolve: null,
		reject: null,
		message: null,
		title: null,
		options:
		{
			color: 'error',
			width: 320,
			zIndex: 200
		}
	}),

	methods:
	{
		open(title, message, options)
		{
			this.dialog = true;
			this.title = title;
			this.message = message;
			this.options = Object.assign(this.options, options);

			if (!options) this.options.color = 'primary';
			if (options && !options.color) this.options.color = 'primary';
			
			/* return new Promise((resolve, reject) =>
			{
				this.resolve = resolve
				this.reject = reject
			}) */
		},

		ok()
		{
			this.dialog = false
		}
	}
}
</script>